<template>
    <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
        <div class="main">
            <div class="actions">
                <h3 style="font-size:28px;"> Purchase Orders </h3>
                <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;">
                    <div class=" d-flex justify-content-between pt-1 mr-4">
                    <p class="pt-1 mr-2">Filter By Status: </p>
                    <a-select default-value="all" style="width: 190px" @change="onInvoiceChange">
                        <a-select-option value="all">
                            All
                        </a-select-option>
                        <a-select-option value="0">
                            Draft
                        </a-select-option>
                        <a-select-option value="1">
                            Pending
                        </a-select-option>
                        <a-select-option value="2">
                            Receiving
                        </a-select-option>
                        <a-select-option value="3">
                            Completed
                        </a-select-option>
                        <a-select-option value="4">
                            Cancelled
                        </a-select-option>
                    </a-select>
                </div>

                <a-button @click="exportExcell" style="height:38px;border-raduis:5px; background: #418a49; color:#fff;"
                    icon="export">
                    Export
                </a-button>
            </div>
        </div>

        <all-purchase-orders @orderData="orderData" @orderStatus="orderStatus"
            :purchaseOrdersData="tableAllPurchaseOrders"></all-purchase-orders>
        </div>

    </a-card>


</template>

<script>

import moment from 'moment';
// import _ from 'lodash';
import XLSX from "xlsx";
import {  mapActions } from 'vuex';

import { NotificationMixins } from '@/mixins/NotificationMixins'
import AllPurchaseOrders from "./tables/AllPurchaseOrders.vue"

const tablePurchaseOrders = []

    export default {
        name: "PurchaseOrderHistory",
        components:{
            AllPurchaseOrders,
        },
        data(){
            return{
                tableAllPurchaseOrders: [],
                availablePurchaseOrders: [],
                tablePurchaseOrders,
                loading: false,
                params:{
                    page: -1,
                    perPage:-1,
                    searchBy: {},
                    sortBy: {}
                },
            }
        },
        mixins: [ NotificationMixins ],
        methods:{
            ...mapActions(['addStockToWarehouse']),
            redirectPreviousUrl(){
                this.$router.back()
            },  
            exportExcell(){
                // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
                const dataToExport = [
                    [
                        "ID",
                        "Supplier Name",
                        "User Name",
                        "Created At",
                        "Status"
                    ],
                ];
            
                this.tableAllPurchaseOrders.forEach((v) => {
                        dataToExport.push([
                            v.id,
                            v.supplierName,
                            v.userName,
                            v.createdAt,
                            v.statusLabel
                        ]);
                });

                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.aoa_to_sheet(dataToExport);

                /* Add the worksheet to the workbook */
                XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

                /* generate file and send to client */
                XLSX.writeFile(wb, `Export-Purchase-Orders-History-${moment().format('DD-MM-YYYY')}.xlsx`);
                this.showSuccessAlert("Data Successfully Exported")
            },
            getAllPurchaseOrderData(response){
                this.table
                if(response.status === 200){
                    this.availablePurchaseOrders = response.data.data;
                    this.tableAllPurchaseOrders = response.data.data.map(order => ({
                        key: order.id,
                        id: order.id,
                        supplierName: order.supplierName,
                        purchaseDate: order.purchaseDate ? order.purchaseDate : "N/A",
                        totalAmount: order.totalAmount ? order.totalAmount : "N/A",
                        wareHouse: order.wareHouse ? order.wareHouse : "N/A",
                        terms: order.terms ? order.terms : "N/A",
                        userName: order.userName,
                        createdAt: moment(order.createdAt).format("DD-MMM-YYYY"),
                        statusLabel: order.statusLabel,
                        action: order
                    }))
                }else{
                    // console.log("Error | ", response)
                }
            },

            async orderData(data){
                // console.log("data | ",data)
                if (data) {
                    this.loadPurchaseOrder();
                }  
            },

            onInvoiceChange(value){
                let result = []
                if(value == "all"){
                    result = this.availablePurchaseOrders;
                }else{
                    result = this.availablePurchaseOrders.filter(order => parseInt(order.status) === parseInt(value) )
                }
                this.tableAllPurchaseOrders = result.map(order => ({
                        key: order.id,
                        id: order.id,
                        supplierName: order.supplierName,
                        userName: order.userName,
                        createdAt: moment(order.createdAt).format("DD-MMM-YYYY"),
                        statusLabel: order.statusLabel,
                        action: order
                    }))
            },

            async orderStatus(request_body) {
                const response = await this.$store.dispatch("purchaseOrder/updatePurchaseOrderStatus",request_body, { root: true} )
                if (response.status === 200) {
                    this.showSuccessAlert('Purchase Order Updated Successfully');
                    this.loadPurchaseOrder()
                } else {
                    this.showErrorAlert('Something went wrong');
                }
            },

            async loadPurchaseOrder(){
                this.loading = true;   
                const response = await this.$store.dispatch('purchaseOrder/getGeneratedPurchaseOrders', this.params);
                this.loading = false;
                this.getAllPurchaseOrderData(response)
            }
        },
        created(){
            if(this.loadPurchaseOrder){
                this.loadPurchaseOrder()
            }
        } 
}
</script>

<style scoped>

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;

}

.card-container >>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}
.card-container >>> .ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}

.card-container >>> .ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

 .spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}


</style>